import React, { Component } from "react";
import { getMinutes, getHours } from "./functions";
import { connect } from "react-redux";

class List extends Component{
    componentDidMount(){
        this.props.increment()
    }
    render(){
        return this.props.timestamps.map(
            e => <div key={e.ts} className="ts">
                <div>
                    {
                        this.props.nav === "daily"
                            ? `${getHours(e.ts)}:${getMinutes(e.ts)} hours ago`
                            : new Date(e.ts).toLocaleDateString('nl-NL', { timeZone: 'UTC' })
                    }
                </div>
                <div>
                    [B]:{e.buyingPrice} {/* <i className={`fa fa-angle-double-${e.buyingPrice > buying ? "down":"up"} fa-2x`}/> */}
                </div>
                <div>
                    [S]:{e.sellingPrice} {/* <i className={`fa fa-angle-double-${e.sellingPrice < selling ? "down":"up"} fa-2x`}/> */}
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch, props) => {
    console.log({
        ts: props.timestamps.map(e => e.ts),
        buy: props.timestamps.map(e => e.buyingPrice),
        sell: props.timestamps.map(e => e.sellingPrice)
    })
    return {
        increment: () => dispatch({ type: 'FETCH_ITEM', payload: { timestamps: props.timestamps } }),
        decrement: () => dispatch({ type: 'RESET_ITEM', payload: { timestamps: props.timestamps } })
    };
}

export default connect(null, mapDispatchToProps)(List)


// WEBPACK FOOTER //
// ./src/ui/item/list.js